import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
const scrollToSection = (id: string) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth'
    });
  }
};
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#3D2314] text-[#FAF8F5] pt-20 pb-20 px-4" data-id="element-46">
      {/* Background texture/overlay could go here */}
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5" data-id="element-47"></div>

      <div className="max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-48">
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8
      }} className="text-center lg:text-left" data-id="element-49">
          <div className="inline-block px-4 py-1 border border-[#C9A227] rounded-full text-[#C9A227] text-sm font-medium tracking-wider mb-6" data-id="element-50">
            PACK EDUCATIVO PREMIUM
          </div>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight mb-6 font-serif" data-id="element-51">
            Genios que{' '}
            <span className="text-[#C9A227] italic" data-id="element-52">Transformaron</span> la
            Humanidad
            <span className="block text-2xl md:text-3xl lg:text-4xl mt-2 text-[#C9A227]" data-id="element-53">
              Vol. I
            </span>
          </h1>
          <p className="text-lg md:text-xl text-[#E0D8D0] mb-8 max-w-xl mx-auto lg:mx-0 font-light leading-relaxed" data-id="element-54">
            Aprende de las mentes más brillantes que cambiaron el mundo. Una
            colección exclusiva para inspirar tu pensamiento.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-55">
            <Button size="lg" withIcon onClick={() => scrollToSection('comprar')} data-id="element-56">
              Descargar ahora
            </Button>
            <Button variant="outline" size="lg" onClick={() => scrollToSection('maestros')} data-id="element-57">
              Ver contenido
            </Button>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        y: 50
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative" data-id="element-58">
          <div className="absolute -inset-4 bg-[#C9A227]/20 blur-3xl rounded-full -z-10" data-id="element-59"></div>
          <img src="https://cdn.magicpatterns.com/uploads/a14bLNbskKX1S9LAJLVd2E/MOCKUP_GENIOS_VOL.1.png" alt="Pack Genios que Transformaron la Humanidad Mockup" className="w-full h-auto drop-shadow-2xl transform hover:scale-105 transition-transform duration-700" data-id="element-60" />
        </motion.div>
      </div>
    </section>;
}